// extracted by mini-css-extract-plugin
export default {"loader":"AbsouteLoader_loader__392kk"};